module.exports = __webpack_public_path__ + "img/about_13.e8e4a53d.jpg";